import { default as React } from "react";
import { PhotoPage } from "./pages/Photo";
import { PhotosPage } from "./pages/Photos";
import { PrintPhotos } from "./pages/PrintPhotos";

export class RouteDef {
  matches(path: string) {
    throw new Error("Method not implemented.");
  }
  public path: string;
  public navigation = true;
  private pathParts: string[];
  public renderer: () => React.Component;

  constructor(path: string, renderer: () => any, opts?: {noNavigation: boolean}) {
    this.path = path;
    this.pathParts = this.split(path);
    this.renderer = () => renderer();
    this.navigation = !opts?.noNavigation;
  }

  split(path: string) {
    const res = [];
    for (const part of path.split("/")) {
      if (part) {
        res.push(part);
      }
    }
    return res;
  }

  url(...params: any[]) {
    let res = "";
    for (const n in this.pathParts) {
      if (this.pathParts[n][0] === ":") {
        res += "/" + params.shift();
      } else {
        res += "/" + this.pathParts[n];
      }
    }
    return res || "/";
  }
}

////////////////////////////////////////////////////////////////////////////////////////////////////
// Route configuration
////////////////////////////////////////////////////////////////////////////////////////////////////

export const ROUTES = {
  PRINT_BOOK: new RouteDef(`${process.env.PUBLIC_URL}/print`, () => <PrintPhotos />),
  PHOTOS: new RouteDef(`${process.env.PUBLIC_URL}/`, () => <PhotosPage />),
  PHOTO: new RouteDef(`${process.env.PUBLIC_URL}/photo/:id`, () => <PhotoPage />),
};